// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2YNvE","content":"styles_content__1jyp-","phone":"styles_phone__2_rY-","title":"styles_title__2JtJT"};